import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const LicensePlateIcon = (props) => (
  <SvgIcon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.1001 9.19995C2.1001 8.09995 3.0001 7.19995 4.1001 7.19995H19.9001C21.0051 7.19995 21.9001 8.09495 21.9001 9.19995V14.8C21.9001 15.9 21.0001 16.8 19.9001 16.8H4.1001C3.0001 16.8 2.1001 15.9 2.1001 14.8V9.19995ZM17.1001 11H6.9001C6.3481 11 5.9001 11.448 5.9001 12C5.9001 12.552 6.3481 13 6.9001 13H17.1001C17.6521 13 18.1001 12.552 18.1001 12C18.1001 11.448 17.6521 11 17.1001 11ZM4.5001 8.99995C4.5001 8.66995 4.2301 8.39995 3.9001 8.39995C3.5701 8.39995 3.3001 8.66995 3.3001 8.99995C3.3001 9.32995 3.5701 9.59995 3.9001 9.59995C4.2301 9.59995 4.5001 9.32995 4.5001 8.99995ZM20.7001 8.99995C20.7001 8.66995 20.4301 8.39995 20.1001 8.39995C19.7701 8.39995 19.5001 8.66995 19.5001 8.99995C19.5001 9.32995 19.7701 9.59995 20.1001 9.59995C20.4301 9.59995 20.7001 9.32995 20.7001 8.99995ZM4.5001 15C4.5001 14.67 4.2301 14.4 3.9001 14.4C3.5701 14.4 3.3001 14.67 3.3001 15C3.3001 15.33 3.5701 15.6 3.9001 15.6C4.2301 15.6 4.5001 15.33 4.5001 15ZM20.7001 15C20.7001 14.67 20.4301 14.4 20.1001 14.4C19.7701 14.4 19.5001 14.67 19.5001 15C19.5001 15.33 19.7701 15.6 20.1001 15.6C20.4301 15.6 20.7001 15.33 20.7001 15Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

LicensePlateIcon.propTypes = {
  sx: PropTypes.object,
};

export default LicensePlateIcon;
